import { render, staticRenderFns } from "./OutreachRequestHistory.vue?vue&type=template&id=6e8f0bbe"
import script from "./OutreachRequestHistory.vue?vue&type=script&lang=ts"
export * from "./OutreachRequestHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports